import React, { useEffect, useMemo, useState } from "react"
import DatePicker, { registerLocale } from "react-datepicker"
import { Link } from "react-router-dom"
import axios from "axios"
import Swal from "sweetalert2"
import Loader from "../../components/Loader"
import ContentHeader from "../../components/ContentHeader"
import Volante from "../../assets/images/volante.png"
import es from "date-fns/locale/es"
import "react-datepicker/dist/react-datepicker.css"

registerLocale("es", es)

const layouts = {
  11: { row1: [0, 0, 0, 0, 1], row2: [2, 3, 0, 0, 0], row3: [4, 5, 0, 0, 0], row4: [7, 8, 0, 0, 6], row5: [10, 11, 0, 0, 9] },
  12: { row1: [0, 0, 0, 0, 1], row2: [2, 3, 0, 0, 0], row3: [4, 5, 0, 0, 6], row4: [7, 8, 0, 0, 9], row5: [10, 11, 0, 12, 0] },
  18: { row1: [0, 0, 0, 18, 1], row2: [2, 3, 0, 17, 0], row3: [4, 5, 0, 0, 6], row4: [7, 8, 0, 0, 9], row5: [15, 16, 0, 0, 14], row6: [10, 11, 0, 12, 13] },
  20: { row1: [0, 0, 0, 20, 1], row2: [2, 3, 0, 0, 0], row3: [4, 5, 0, 0, 6], row4: [7, 8, 0, 0, 9], row5: [15, 16, 0, 0, 17], row6: [18, 19, 0, 0, 14], row7: [10, 11, 0, 12, 13] },
}

const dateForApi = (value) => {
  const year = value.getFullYear()
  const month = String(value.getMonth() + 1).padStart(2, "0")
  const day = String(value.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

const formatTime = (value) => value ? value.slice(0, 5) : ""

const normalizeSchedule = (schedule) => ({
  ...schedule,
  schedule_id: schedule.schedule_id ?? schedule.scheduleId ?? schedule.id ?? schedule.schedule?.schedule_id ?? schedule.schedule?.id ?? schedule.trip?.schedule_id,
  time: formatTime(schedule.time),
})

const hasScheduleId = (schedule) => schedule?.schedule_id !== undefined && schedule?.schedule_id !== null && schedule?.schedule_id !== "" && schedule?.schedule_id !== "undefined"
const scheduleOptionValue = (schedule, index) => hasScheduleId(schedule) ? String(schedule.schedule_id) : `time:${schedule.time}:${index}`

const MassTransfer = () => {
  const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT
  const TITLEALERT = process.env.REACT_APP_TITLE_ALERT
  const [loading, setLoading] = useState(false)
  const [branches, setBranches] = useState([])
  const [branchId, setBranchId] = useState("")
  const [sourceDate, setSourceDate] = useState(new Date())
  const [targetDate, setTargetDate] = useState(new Date())
  const [sourceSchedules, setSourceSchedules] = useState([])
  const [targetSchedules, setTargetSchedules] = useState([])
  const [sourceScheduleId, setSourceScheduleId] = useState("")
  const [targetScheduleId, setTargetScheduleId] = useState("")
  const [resolvedTargetScheduleId, setResolvedTargetScheduleId] = useState("")
  const [sourceTime, setSourceTime] = useState("")
  const [targetTime, setTargetTime] = useState("")
  const [tickets, setTickets] = useState([])
  const [targetSeats, setTargetSeats] = useState([])
  const [capacity, setCapacity] = useState(11)
  const [assignments, setAssignments] = useState({})
  const [activeTicketId, setActiveTicketId] = useState(null)
  const [step, setStep] = useState(1)

  const findSchedule = (schedules, selectedId) => schedules.find((item, index) => scheduleOptionValue(item, index) === String(selectedId))
  const sourceSchedule = findSchedule(sourceSchedules, sourceScheduleId)
  const targetSchedule = findSchedule(targetSchedules, targetScheduleId)
  const assignedSeats = Object.values(assignments).filter(Boolean)
  const occupiedTargetSeats = useMemo(() => new Set(
    targetSeats
      .filter((seat) => [1, 2, 4].includes(Number(seat.status)))
      .map((seat) => Number(seat.seat))
      .filter(Boolean),
  ), [targetSeats])
  const availableSeats = useMemo(() => {
    return Array.from({ length: capacity }, (_, index) => index + 1).filter((seat) => !occupiedTargetSeats.has(seat) && !assignedSeats.includes(seat))
  }, [capacity, occupiedTargetSeats, assignedSeats])
  const allAssigned = tickets.length > 0 && tickets.every((ticket) => assignments[ticket.ticket_id])

  useEffect(() => {
    const loadBranches = async () => {
      try {
        const response = await axios.get(ENDPOINT + "get-all-branchs-ticket")
        setBranches((response.data.data || []).map((branch) => ({ label: branch.name, value: branch.branch_id })))
      } catch (error) {
        showError(error)
      }
    }
    loadBranches()
  }, [ENDPOINT])

  const showError = (error) => {
    Swal.fire({ icon: "error", title: TITLEALERT || "Error", text: error.response?.data?.msg || "No fue posible completar la operacion." })
  }

  const loadSchedules = async (date, setter) => {
    if (!branchId) return
    const form = new FormData()
    form.append("branch_id", branchId)
    form.append("date", dateForApi(date))
    const response = await axios.post(ENDPOINT + "get-schedules-day", form)
    const schedules = Array.isArray(response.data.data) ? response.data.data : []
    setter(schedules.map(normalizeSchedule))
  }

  const handleBranchChange = async (value) => {
    setBranchId(value)
    setSourceTime("")
    setTargetTime("")
    setSourceScheduleId("")
    setTargetScheduleId("")
    setSourceSchedules([])
    setTargetSchedules([])
    if (!value) return
    setLoading(true)
    try {
      const form = new FormData()
      form.append("branch_id", value)
      form.append("date", dateForApi(sourceDate))
      const response = await axios.post(ENDPOINT + "get-schedules-day", form)
      const schedules = (Array.isArray(response.data.data) ? response.data.data : []).map(normalizeSchedule)
      setSourceSchedules(schedules)
      if (dateForApi(sourceDate) === dateForApi(targetDate)) setTargetSchedules(schedules)
    } catch (error) {
      showError(error)
    } finally {
      setLoading(false)
    }
  }

  const handleSourceDateChange = async (value) => {
    setSourceDate(value)
    setSourceTime("")
    setSourceScheduleId("")
    if (!branchId) return
    setLoading(true)
    try { await loadSchedules(value, setSourceSchedules) } catch (error) { showError(error) } finally { setLoading(false) }
  }

  const handleTargetDateChange = async (value) => {
    setTargetDate(value)
    setTargetTime("")
    setTargetScheduleId("")
    if (!branchId) return
    setLoading(true)
    try { await loadSchedules(value, setTargetSchedules) } catch (error) { showError(error) } finally { setLoading(false) }
  }

  const loadSourceTickets = async () => {
    if (!branchId || !sourceTime || !targetTime || !sourceScheduleId || !targetScheduleId || !targetSchedule) {
      Swal.fire({ icon: "warning", title: "Completa la seleccion", text: "Elige base, fecha y ambos horarios validos." })
      return
    }
    if (dateForApi(sourceDate) === dateForApi(targetDate) && sourceTime === targetTime) {
      Swal.fire({ icon: "warning", title: "Horarios iguales", text: "El horario destino debe ser diferente al horario de origen." })
      return
    }
    setLoading(true)
    try {
      const form = new FormData()
      form.append("branch_id", branchId)
      form.append("date", dateForApi(sourceDate))
      form.append("time", sourceTime)
      const response = await axios.post(ENDPOINT + "seach-binnacle", form)
      const data = (response.data.data || []).filter((ticket) => ticket.ticket_id)
      if (!data.length) throw new Error("No hay boletos activos en el horario de origen.")
      setTickets(data)

      const firstTicket = data[0]
      const tripResponse = await axios.post(ENDPOINT + "search-trip", (() => {
          const searchForm = new FormData()
          searchForm.append("branch_id", branchId)
          searchForm.append("origin_id", firstTicket.origin_id || 0)
          searchForm.append("destination_id", firstTicket.destination_id || 0)
          searchForm.append("date", dateForApi(targetDate))
          searchForm.append("type", "admin")
          searchForm.append("user_role", 1)
          return searchForm
        })())
      const targetTrip = (tripResponse.data.data || []).find((trip) => formatTime(trip.time) === targetTime)
      const targetScheduleIdValue = targetSchedule.schedule_id ?? targetTrip?.schedule_id
      if (!hasScheduleId({ schedule_id: targetScheduleIdValue })) {
        throw new Error("No se encontro el ID de la corrida destino.")
      }
      const seatForm = new FormData()
      seatForm.append("schedule_id", String(targetScheduleIdValue))
      seatForm.append("date", dateForApi(targetDate))
      const seatResponse = await axios.post(ENDPOINT + "get-all-booking-seats", seatForm)
      const normalizedSeats = (seatResponse.data.data || []).map((seat) => ({
        ...seat,
        seat: Number(seat.seat),
        status: Number(seat.status),
      }))
      setTargetSeats(normalizedSeats)
      setCapacity(Number(targetTrip?.available) || 11)
      setResolvedTargetScheduleId(String(targetScheduleIdValue))
      setAssignments({})
      setActiveTicketId(data[0].ticket_id)
      setStep(2)
    } catch (error) {
      showError(error.message ? { response: { data: { msg: error.message } } } : error)
    } finally {
      setLoading(false)
    }
  }

  const assignSeat = (seat) => {
    if (!activeTicketId || !seat || assignedSeats.includes(seat)) return
    setAssignments((current) => ({ ...current, [activeTicketId]: seat }))
    const nextTicket = tickets.find((ticket) => !assignments[ticket.ticket_id] && ticket.ticket_id !== activeTicketId)
    setActiveTicketId(nextTicket?.ticket_id || null)
  }

  const clearAssignment = (ticketId) => {
    setAssignments((current) => { const next = { ...current }; delete next[ticketId]; return next })
    setActiveTicketId(ticketId)
  }

  const autoAssign = () => {
    const next = { ...assignments }
    let seats = [...availableSeats]
    tickets.forEach((ticket) => {
      if (!next[ticket.ticket_id] && seats.length) next[ticket.ticket_id] = seats.shift()
    })
    setAssignments(next)
    setActiveTicketId(tickets.find((ticket) => !next[ticket.ticket_id])?.ticket_id || null)
  }

  const executeTransfer = async () => {
    const user = JSON.parse(localStorage.getItem("dataUser") || "{}")
    const confirmed = await Swal.fire({ icon: "question", title: "Confirmar transferencia", text: `Se moveran ${tickets.length} boletos al horario ${targetTime}.`, showCancelButton: true, confirmButtonText: "Transferir", cancelButtonText: "Cancelar" })
    if (!confirmed.isConfirmed) return
    setLoading(true)
    try {
      for (const ticket of tickets) {
        const form = {
          ticket_id: ticket.ticket_id,
          new_date: dateForApi(targetDate),
          new_schedule_id: resolvedTargetScheduleId,
          new_time: targetTime,
          new_seat: assignments[ticket.ticket_id],
          branch_id: branchId,
          origin_id: ticket.origin_id,
          destination_id: ticket.destination_id,
          user_id: user.user_id,
        }
        await axios.post(ENDPOINT + "transfer-ticket", form)
      }
      await Swal.fire({ icon: "success", title: "Transferencia completada", text: "Todos los boletos fueron reubicados." })
      setTickets([])
      setAssignments({})
      setStep(1)
    } catch (error) {
      showError(error)
    } finally {
      setLoading(false)
    }
  }

  const reset = () => {
    setTickets([]); setAssignments({}); setTargetSeats([]); setSourceTime(""); setTargetTime(""); setSourceScheduleId(""); setTargetScheduleId(""); setResolvedTargetScheduleId(""); setStep(1)
  }

  return (
    <>
      {loading && <Loader />}
      <div className="container-fluid"><ContentHeader title="Transferencias masivas" /></div>
      <div className="container-fluid mass-transfer-page">
        <div className="card mass-transfer-shell">
          <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div><h4 className="card-title mb-1"><i className="fa-solid fa-right-left me-2"></i>Transferencia masiva de boletos</h4><small className="text-muted">Reubica pasajeros de una corrida a otra en pocos pasos.</small></div>
            <Link to="/bitacora" className="btn btn-outline-secondary btn-sm"><i className="fa-solid fa-arrow-left me-1"></i>Bitacora</Link>
          </div>
          <div className="card-body">
            <div className="mass-transfer-steps mb-4"><span className={step === 1 ? "active" : "done"}>1. Corridas</span><span className={step === 2 ? "active" : ""}>2. Asientos</span><span>3. Confirmar</span></div>
            {step === 1 ? (
              <div className="row g-3 align-items-end">
                <div className="col-md-3"><label className="form-label">Base</label><select className="form-select" value={branchId} onChange={(event) => handleBranchChange(event.target.value)}><option value="">Seleccione base</option>{branches.map((branch) => <option key={branch.value} value={branch.value}>{branch.label}</option>)}</select></div>
                <div className="col-md-2"><label className="form-label">Fecha origen</label><DatePicker locale="es" selected={sourceDate} onChange={handleSourceDateChange} className="form-control" dateFormat="dd/MM/yyyy" /></div>
                <div className="col-md-2"><label className="form-label">Horario origen</label><select className="form-select" value={sourceScheduleId} onChange={(event) => { const selected = findSchedule(sourceSchedules, event.target.value); setSourceScheduleId(event.target.value); setSourceTime(selected?.time || "") }}><option value="">Seleccione</option>{sourceSchedules.map((item, index) => <option key={scheduleOptionValue(item, index)} value={scheduleOptionValue(item, index)}>{item.time}</option>)}</select></div>
                <div className="col-md-2"><label className="form-label">Fecha destino</label><DatePicker locale="es" selected={targetDate} onChange={handleTargetDateChange} className="form-control" dateFormat="dd/MM/yyyy" /></div>
                <div className="col-md-2"><label className="form-label">Horario destino</label><select className="form-select" value={targetScheduleId} onChange={(event) => { const selected = findSchedule(targetSchedules, event.target.value); setTargetScheduleId(event.target.value); setTargetTime(selected?.time || "") }}><option value="">Seleccione</option>{targetSchedules.map((item, index) => <option key={scheduleOptionValue(item, index)} value={scheduleOptionValue(item, index)}>{item.time}</option>)}</select></div>
                <div className="col-md-1"><button className="btn btn-primary w-100" onClick={loadSourceTickets} title="Cargar pasajeros"><i className="fa-solid fa-arrow-right"></i></button></div>
              </div>
            ) : (
              <>
                <div className="mass-transfer-summary mb-4"><div><small>ORIGEN</small><strong>{dateForApi(sourceDate)} | {sourceTime}</strong></div><i className="fa-solid fa-arrow-right"></i><div><small>DESTINO</small><strong>{dateForApi(targetDate)} | {targetTime}</strong></div><div className="summary-count"><small>BOLETOS</small><strong>{tickets.length}</strong></div></div>
                <div className="row g-4">
                  <div className="col-lg-5"><div className="mass-transfer-panel"><div className="panel-heading"><h5>Pasajeros</h5><button type="button" className="btn btn-sm btn-outline-primary" onClick={autoAssign}><i className="fa-solid fa-wand-magic-sparkles me-1"></i>Asignar rapido</button></div><p className="text-muted small">Selecciona un pasajero y despues un asiento en el croquis.</p>{tickets.map((ticket) => <button type="button" key={ticket.ticket_id} className={`passenger-row ${activeTicketId === ticket.ticket_id ? "selected" : ""}`} onClick={() => setActiveTicketId(ticket.ticket_id)}><span className="passenger-seat">{assignments[ticket.ticket_id] || ticket.seat}</span><span><strong>{ticket.name} {ticket.last_name}</strong><small>Asiento anterior: {ticket.seat} | Folio: {ticket.invoice}</small></span>{assignments[ticket.ticket_id] && <i className="fa-solid fa-circle-check text-success"></i>}<span className="passenger-clear" onClick={(event) => { event.stopPropagation(); clearAssignment(ticket.ticket_id) }}><i className="fa-solid fa-xmark"></i></span></button>)}</div></div>
                  <div className="col-lg-7"><div className="mass-transfer-panel"><div className="panel-heading"><h5>Croquis destino</h5><span className="badge bg-light text-dark">{assignedSeats.length}/{tickets.length} asignados</span></div><div className="seat-legend mb-3"><span><i className="seat-dot available"></i>Disponible</span><span><i className="seat-dot assigned"></i>Asignado</span><span><i className="seat-dot occupied"></i>Ocupado</span></div><div className="mass-bus-layout"><img src={Volante} alt="Volante" className="mass-driver" />{Object.values(layouts[capacity] || layouts[11]).map((row, index) => <div className="mass-bus-row" key={index}>{row.slice(0, 2).map((seat, seatIndex) => <React.Fragment key={`left-${index}-${seatIndex}`}>{seat ? <button type="button" className={`mass-seat ${assignedSeats.includes(seat) ? "assigned" : occupiedTargetSeats.has(seat) ? "occupied" : "available"}`} disabled={assignedSeats.includes(seat) || occupiedTargetSeats.has(seat)} onClick={() => assignSeat(seat)}>{seat}</button> : <span className="mass-seat-space" />}</React.Fragment>)}<span className="mass-aisle" />{row.slice(3).map((seat, seatIndex) => <React.Fragment key={`right-${index}-${seatIndex}`}>{seat ? <button type="button" className={`mass-seat ${assignedSeats.includes(seat) ? "assigned" : occupiedTargetSeats.has(seat) ? "occupied" : "available"}`} disabled={assignedSeats.includes(seat) || occupiedTargetSeats.has(seat)} onClick={() => assignSeat(seat)}>{seat}</button> : <span className="mass-seat-space" />}</React.Fragment>)}</div>)}</div></div></div>
                </div>
                <div className="d-flex justify-content-between mt-4"><button className="btn btn-outline-secondary" onClick={reset}><i className="fa-solid fa-arrow-left me-1"></i>Cambiar corridas</button><button className="btn btn-success" disabled={!allAssigned} onClick={executeTransfer}><i className="fa-solid fa-check me-1"></i>Transferir {tickets.length} boletos</button></div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default MassTransfer
